import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { PriceConstraintSchema } from "../integration/redo-in-shipping/rate-table-constraints";
import { DynamicRateRounding } from "../integration/redo-in-shipping/shipping-rate-table";

export enum MercuryModelMode {
  ENABLED = "ENABLED",
  SHADOW = "SHADOW",
  DISABLED = "DISABLED",
}

const MercuryModelConfigSchema_ = z.object({
  rateTableConfigByRateTableId: z.record(
    z.string(), // rate table id
    z.object({
      isConditionallyDisplayed: z.boolean(),
      isDeliveryDateDisplayed: z.boolean(),
      rounding: z.enum(DynamicRateRounding).nullish(),
      priceConstraints: PriceConstraintSchema.nullish(),
    }),
  ),
});
export interface MercuryModelConfig
  extends z.infer<typeof MercuryModelConfigSchema_> {}

const MercuryModelSchema_ = z.object({
  _id: zExt.objectId(),

  team: zExt.objectId(),

  checkoutExperienceId: zExt.objectId(),

  config: MercuryModelConfigSchema_,

  hasRecordedData: z.boolean().nullish(),

  mode: z.enum(MercuryModelMode).nullish(),

  assumedOrderMargin: z
    .object({ percentage: z.number().optional(), fixed: z.number().optional() })
    .nullish(),

  createdAt: z.date(),
  updatedAt: z.date(),
});

export const MercuryModelSchema: z.ZodType<MercuryModel> = MercuryModelSchema_;
export interface MercuryModel extends z.infer<typeof MercuryModelSchema_> {}
export type CreateMercuryModel = Omit<
  MercuryModel,
  "_id" | "createdAt" | "updatedAt"
>;
